import { Box, Heading, Flex, Button } from '@ritualco/jutsu'
import { useNetworkListQuery } from 'api/endpoints/merchantLists'
import { NetworkMerchantsTable } from 'components/Tables/NetworkMerchantsTable'
import { useContent } from 'lib/content/react'
import Loading from 'components/Loading'
import { mapToNetworkList } from 'api/mappers/networkList'
import { Link } from 'lib/router'

type NetworkSectionProps = {
  organizationId: string
  workspaceId: string
}

export const NetworkSection = ({
  workspaceId,
  organizationId,
}: NetworkSectionProps) => {
  const { formatMessage } = useContent()
  const { status, data } = useNetworkListQuery(organizationId, workspaceId)

  if (status === 'loading') {
    return <Loading />
  }

  if (status === 'error') {
    // TODO: handle error state
    return <span>Something went wrong!</span>
  }

  const merchants = data?.merchants
  const listId = data?.merchantListId

  return (
    <Box>
      <Flex alignItems="center" justifyContent="space-between" py={3}>
        <Heading as="h3" size="lg">
          {formatMessage({ id: 'pmportal.restaurantLists.networkTitle' })}
        </Heading>
        {listId && (
          <Button>
            <Link to={`/workspaces/${workspaceId}/restaurants/lists/${listId}`}>
              {formatMessage({ id: 'pmportal.global.actionViewDetails' })}
            </Link>
          </Button>
        )}
      </Flex>
      <NetworkMerchantsTable merchants={merchants} />
    </Box>
  )
}
